// Regra de divisão equilibrada de splits (espelha backend/app/lib/splits.py)

/** eRS padrão de um piloto sem movimentação (COALESCE(current_ers, 1200.0) do SQL) */
export const DEFAULT_ERS = 1200;

/**
 * Calcula o tamanho de cada split de forma equilibrada.
 *
 * Regras:
 *  - Divisão o mais equilibrada possível entre os splits.
 *  - Splits nunca decrescem em tamanho (Split 1 <= Split 2 <= ...).
 *  - Diferença entre maior e menor split de no máximo 1 piloto.
 *  - A sobra vai sempre para os ÚLTIMOS splits (menor eRS).
 *
 * Exemplos:
 *  (25, 2) -> [12, 13]
 *  (32, 2) -> [16, 16]
 *  (47, 3) -> [15, 16, 16]
 */
export function computeSplitSizes(totalPilots: number, numSplits: number): number[] {
  if (numSplits <= 1) return [totalPilots];
  const base = Math.floor(totalPilots / numSplits);
  const remainder = totalPilots % numSplits;
  return [
    ...Array(numSplits - remainder).fill(base),
    ...Array(remainder).fill(base + 1),
  ];
}
